import { render } from "./intro.vue?vue&type=template&id=04a97c97&scoped=true"
import script from "./intro.vue?vue&type=script&lang=js"
export * from "./intro.vue?vue&type=script&lang=js"

import "./intro.vue?vue&type=style&index=0&id=04a97c97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a97c97"]])

export default __exports__